import { QueryClient } from "@tanstack/solid-query";
import { experimental_createQueryPersister } from "@tanstack/query-persist-client-core";
import lz from "lz-string";

const persister = experimental_createQueryPersister({
  serialize: (data) => lz.compressToUTF16(JSON.stringify(data)),
  deserialize: (data) => JSON.parse(lz.decompressFromUTF16(data)),
  storage: window.localStorage,
  maxAge: 1000 * 60 * 60 * 12,
  prefix: "@brytdesigns/shopify-ajax-cart",
});

const client = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 5,
      persister: persister.persisterFn,
    },
  },
});

export default client;
